// src/App.js
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Link as RouterLink } from "react-router-dom";
import { CssBaseline, GlobalStyles, Box, Typography, Link } from "@mui/material";
import MainLayout from "./Layout/MainLayout";
import CookieBanner from "./components/CookieBanner";

// Importa las páginas de forma diferida
const Home = lazy(() => import("./pages/Home"));
const Modulo1Calculadora = lazy(() => import("./pages/Modulo1Calculadora"));
const Modulo2Estimador = lazy(() => import("./pages/Modulo2Estimador"));
const Modulo3Historico = lazy(() => import("./pages/Modulo3Historico"));
const Modulo4Hormigon = lazy(() => import("./pages/Modulo4Hormigon"));
const QuienesSomos = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const AvisoLegal = lazy(() => import("./pages/aviso-legal"));
const PoliticaCookies = lazy(() => import("./pages/politica-cookies"));
const PoliticaPrivacidad = lazy(() => import("./pages/politica-privacidad"));





// Componente Footer con fondo oscuro y enlaces a Contacto y páginas legales
function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <Box
      sx={{
        backgroundColor: "#333",
        color: "#fff",
        py: 2,
        mt: 4,
        textAlign: "center",
      }}
    >

     
      
      <Typography variant="body2">

        <Link
          component={RouterLink}
          to="/about"
          sx={{ color: "#fff", mx: 1, textDecoration: "none" }}
        >
          Quienes somos?
        </Link>
        |
        <Link
          component={RouterLink}
          to="/contact"
          sx={{ color: "#fff", mx: 1, textDecoration: "none" }}
        >
          Contacto
        </Link>
        |
        <Link
          component={RouterLink}
          to="/aviso-legal"
          sx={{ color: "#fff", mx: 1, textDecoration: "none" }}
        >
          Aviso Legal
        </Link>
        |
        <Link
          component={RouterLink}
          to="/politica-cookies"
          sx={{ color: "#fff", mx: 1, textDecoration: "none" }}
        >
          Política de Cookies
        </Link>
        |
        <Link
          component={RouterLink}
          to="/politica-privacidad"
          sx={{ color: "#fff", mx: 1, textDecoration: "none" }}
        >
          Política de Privacidad
        </Link>
      </Typography>
      <Typography variant="body2" sx={{ mb: 1 }}>
        CALCU OBRA ARG © {currentYear}
      </Typography>
      <Typography variant="caption" sx={{ display: "block", mt: 1 }}>
  Versión 1.1c
</Typography>

    </Box>
  );
}

function App() {
  return (
    <BrowserRouter>
      <CssBaseline />
      <GlobalStyles
        styles={{
          h1: { fontFamily: "'Bebas Neue', sans-serif" },
          h2: { fontFamily: "'Bebas Neue', sans-serif" },
          h3: { fontFamily: "'Bebas Neue', sans-serif" },
          h4: { fontFamily: "'Bebas Neue', sans-serif" },
          h5: { fontFamily: "'Bebas Neue', sans-serif" },
          h6: { fontFamily: "'Bebas Neue', sans-serif" },
        }}
      />
      <Suspense fallback={<div>Cargando...</div>}>
        <Routes>
          {/* Ruta principal con layout */}
          <Route path="/" element={<MainLayout />}>
            {/* Página de inicio */}
            <Route index element={<Home />} />
            {/* Módulos */}
            <Route path="calculadora-materiales" element={<Modulo1Calculadora />} />
            <Route path="presupuestador-obras" element={<Modulo2Estimador />} />
            <Route path="historico-precios" element={<Modulo3Historico />} />
            <Route path="hormigon-armado" element={<Modulo4Hormigon />} />
            {/* Páginas adicionales */}
            <Route path="about" element={<QuienesSomos />} />
            <Route path="contact" element={<Contact />} />
            <Route path="aviso-legal" element={<AvisoLegal />} />
            <Route path="politica-cookies" element={<PoliticaCookies />} />
            <Route path="politica-privacidad" element={<PoliticaPrivacidad />} />
          </Route>
        </Routes>
      </Suspense>
      <CookieBanner />
      <Footer />
    </BrowserRouter>
  );
}
export default App;
